export function isScheduleStartAfterToday(startDate: string | Date): boolean {
  const d = typeof startDate === "string" ? new Date(startDate) : startDate;
  if (Number.isNaN(d.getTime())) return false;
  const courseDay = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return courseDay.getTime() > today.getTime();
}
